module.exports = __webpack_public_path__ + "img/imv_qr.a45a867b.jpg";